import { getSdk } from "./sdkService";
import { i18n } from "./i18nService";
import { getNumericParentalLevelFromLocalStorage } from "./parentalControlService";
import { isGuestUserLoggedIn, getGuestUserID } from "../utils/guestProfileUtil";

export const EPG_API_CHANNEL_LIMIT = 500; // 500 CHANNEL

export async function getEpgCategories(params) {
  try {
    const userId = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");
    const sdk = await getSdk();
    return await sdk.mediaManager.getCategoryConfigV1({
      lang: i18n.getLocale() || "en",
      profileType: params?.profileType,
      ["x-geo-country"]: params?.xgeoCountry,
      avoidCache: params.avoidCache || false,
      pg: getNumericParentalLevelFromLocalStorage(),
      guid: userId
    });
  } catch (error) {
    throw error;
  }
}

export async function getEpgEvents(params) {
  try {
    const userId = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");

    const sdk = await getSdk();
    return await sdk.mediaManager.getCategoryEventsV1({
      category: params.category,
      ts_start: params.ts_start || 1698151204,
      ts_end: params.ts_end || 1698237604,
      lang: i18n.getLocale() || "en",
      profileType: params?.profileType,
      ["x-geo-country"]: params?.xgeoCountry,
      pg: getNumericParentalLevelFromLocalStorage(),
      page: params.page || 1,
      limit: params.limit || EPG_API_CHANNEL_LIMIT,
      avoidCache: params.avoidCache || false,
      guid: userId
    });
  } catch (error) {
    throw error;
  }
}

export async function firstPlaybackChannelEventsService(params) {
  try {
    const sdk = await getSdk();
    return await sdk.mediaManager.firstPlaybackChannelEvents({
      ts_start: params.ts_start,
      ts_end: params.ts_end,
      profileType: params?.profileType,
      ["x-geo-country"]: params?.xgeoCountry,
      lang: i18n.getLocale() || "en",
      pg: getNumericParentalLevelFromLocalStorage(),
      avoidCache: params.avoidCache || false
    });
  } catch (error) {
    console.log("error ==>", error);
    throw error;
  }
}

export async function addToFavorite(channelId) {
  try {
    const userId = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");
    const body = {
      user_id: userId,
      favourites: [channelId.toString()]
    };
    const sdk = await getSdk();
    return await sdk.mediaManager.favouriteEpgChannel(body);
  } catch (error) {
    throw error;
  }
}

export async function removeFromFavorite(channelId) {
  try {
    const userId = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");
    const body = {
      user_id: userId,
      favourites: [channelId.toString()]
    };
    const sdk = await getSdk();
    return await sdk.mediaManager.removeFavouriteEpgChannel(body);
  } catch (error) {
    throw error;
  }
}

export async function getUserFavoriteEpgChannels() {
  const sdk = await getSdk();
  const {
    stateActions: { setForceLogout }
  } = this.props;
  try {
    const userId = isGuestUserLoggedIn() ? getGuestUserID() : localStorage.getItem("globalUserId");
    const list = await sdk.mediaManager.getFavouriteEpgChannels({ guid: userId });
    return (list.data && list.data.favourites) || [];
  } catch (e) {
    await setForceLogout(e);
  }
}
